// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"59":"a906afce","550":"6eeb522d","620":"b0f52ed8","639":"c06507a3","679":"ace96033"}[chunkId] + ".js";
};